module.exports = __webpack_public_path__ + "static/img/456x206.c346990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/456x206.png
// module id = oROX
// module chunks = 8